import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subscription } from 'rxjs';
import { ConfigurationImportProcess } from 'src/app/_models';
import { ConfigurationService } from 'src/app/_services';
import { DesignVersionEnum } from 'src/app/_enums/design-version.enum';

@Component({
  selector: 'app-new-process-import',
  template: `
    <div class="loading-wrapper">
      <div class="loading"></div>
    </div>
    <div class="app-container" appCustomV2DesignLayout>
      <app-snav-menu-controller class="app-side fixed" id="app-side"></app-snav-menu-controller>
      <!-- BEGIN .app-main -->
      <div class="app-main">

        <ng-container *ngIf="pymImportType === 'V1'">
          <paymentcustomerimportv1></paymentcustomerimportv1>
        </ng-container>

        <ng-container *ngIf="pymImportType === 'V2'">
          <app-newpaymentcustomerimport></app-newpaymentcustomerimport>
  
        </ng-container>

      </div>
      <!-- END: .app-main -->
    </div>
  `,
  styleUrls: ['./new-process-import.component.css']
})
export class NewProcessImportCustomerComponent implements OnInit {

  customerPuplic_key: string;
  importationConfiguration$: Subscription;
  pymImportType: 'V1' | 'V2' | null = null;
  configurationData: ConfigurationImportProcess;

  constructor(
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private configurationService: ConfigurationService
  ) { }

  ngOnInit() {
    this.spinnerService.show();
    this.checkCredentials();
    this.getImportConfigurationCustomer();
  }

  checkCredentials() {
    if ((localStorage.getItem('companyId') != null || localStorage.getItem('companyId') !== '') && (localStorage.getItem('application') != null || localStorage.getItem('application') !== '')) {
      if (localStorage.getItem('isCorporate') === 'Yes') {
        this.customerPuplic_key = localStorage.getItem('subcompanyId');
      } else {
        this.customerPuplic_key = localStorage.getItem('companyId');
      }
    } else {
      this.router.navigate(['/home']);
    }
  }

  getImportConfigurationCustomer() {
    const urlConfig = 'debtors_import.configuration';
    this.importationConfiguration$ = this.configurationService.getImportConfigurationCustomer(this.customerPuplic_key, urlConfig).subscribe(data => {
      const configurationData = data;
      if (configurationData && configurationData.values && configurationData.values.import_process) {
        const pymImportacionValue = configurationData.values.import_process.version;
        if ((pymImportacionValue != null && pymImportacionValue.trim().length > 0) && (pymImportacionValue === "V1" || pymImportacionValue === "V2")) {
          this.configurationData = configurationData;
          this.pymImportType = pymImportacionValue;
        } else {
          this.pymImportType = "V1";
        }
      } else {
        this.pymImportType = "V1";
      }
      this.spinnerService.hide();
      console.log(this.pymImportType);
    }, error => {
      this.pymImportType = "V1";
      console.error('Failed! while trying to get payment importation configuration. ' + error);
      this.spinnerService.hide();
    });
  }

  ngOnDestroy() {
    this.importationConfiguration$.unsubscribe();
  }

}
